export default {
    initializeCptProduct({commit, rootState}) {
        const maxId = Math.max(0, ...rootState["cart-app"].products.map((p) => p.id))
        commit('setCptProduct', maxId + 1)
    }
}
